import React, { useState, useContext } from "react";
import { BiX } from "react-icons/bi";
import { VoxSoftwaresContext } from "../../../../contexts/voxSoftwaresProvider";
import BaseSelect from "../../../General/FormsComp/Select/BaseSelect";
import VoxChatForm from "../../forms/VoxChatForm";
import EdutechForm from "../../forms/EdutechForm";

const NovoVinculo = ({ selectedCliente, closeModal }) => {
  const { createVinculo, softwares, templateVinculo, clientes, setAlert } = useContext(VoxSoftwaresContext);
  const [localCliente, setLocalCliente] = useState(selectedCliente);
  const [selectedSoftware, setSelectedSoftware] = useState('');
  const [vinculo, setVinculo] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClickOutside = (e) => {
    if(e.target.classList.contains('novo-vinculo-modal')) {
        closeModal()
    }
  }

  const handleSoftwareChange = (e) => {
    const softwareId = e.target.value;
    setSelectedSoftware(softwareId);
    if (softwareId && templateVinculo[softwareId]) {
      setVinculo({ ...templateVinculo[softwareId] });
    } else {
      setVinculo(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!localCliente) {
      setAlert({ visible: true, title: "Atenção", placeholder: "Selecione um cliente antes de criar o vínculo.", confirm: false, type: "warning" });
      return;
    }

    setLoading(true);

    try {
      const result = await createVinculo(vinculo, localCliente.id);
      if (result?.sucesso) {
        setSelectedSoftware('');
        setVinculo(null);
        setLocalCliente(null);
        closeModal();
      }
    } catch (error) {
      console.error('Erro ao criar vínculo:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClienteChange = (e) => {
    const clienteId = e.target.value;
    if (clienteId) {
      const cliente = clientes.find(c => c.id === clienteId);
      setLocalCliente(cliente);
    } else {
      setLocalCliente(null);
    }
  };

  const renderForm = () => {
    if (!vinculo) return null;

    switch (selectedSoftware) {
      case 'voxchat':
        return <VoxChatForm vinculo={vinculo} setVinculo={setVinculo} />;
      case 'edutech':
        return <EdutechForm vinculo={vinculo} setVinculo={setVinculo} />;
      default:
        return null;
    }
  };

  const isFormValid = localCliente && selectedSoftware && vinculo && 
    vinculo.nome_organizacao?.trim() && 
    vinculo.email_cliente?.trim() && 
    vinculo.senha?.trim();

  return (
    <div className="novo-vinculo-modal" onClick={handleClickOutside}>
      <div className="bg-white dark:bg-gray-800 rounded-xl p-6 w-11/12 max-w-2xl max-h-[100vh] overflow-auto shadow-2xl min-h-[50%]">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white m-0">
              Novo Vínculo
            </h2>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              {localCliente ? `Criar vínculo para ${localCliente.nome || localCliente.razaosocial || 'cliente'}` : 'Selecione um cliente e software'}
            </p>
          </div>
          <BiX 
            onClick={closeModal}
            className="text-2xl text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 cursor-pointer p-1 transition-colors"
          />
        </div>

        <form onSubmit={handleSubmit}>
          <div className="flex flex-col gap-4">
            {!selectedCliente && (
              <BaseSelect
                label="Selecione o Cliente"
                name="cliente"
                value={localCliente?.id || ''}
                onChange={handleClienteChange}
                options={clientes || []}
                placeholder="Escolha um cliente..."
                valueKey="id"
                labelKey="nome"
                searchable={true}
                required={true}
              />
            )}

            <BaseSelect
              label="Selecione o Software"
              name="software"
              value={selectedSoftware}
              onChange={handleSoftwareChange}
              options={softwares}
              placeholder="Escolha um software..."
              valueKey="id"
              labelKey="nome"
              searchable={false}
              required={true}
            />

            {renderForm()}
          </div>

          <div className="flex justify-end gap-3 mt-6 pt-5 border-t border-gray-200 dark:border-gray-700">
            <button
              type="button"
              onClick={closeModal}
              className="px-5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg 
                       bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300
                       hover:bg-gray-50 dark:hover:bg-gray-600
                       text-sm font-medium cursor-pointer transition-colors"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={!isFormValid || loading}
              className={`px-5 py-2.5 border-none rounded-lg text-white text-sm font-medium transition-colors
                ${isFormValid && !loading 
                  ? 'bg-green-600 hover:bg-green-700 cursor-pointer' 
                  : 'bg-gray-400 dark:bg-gray-600 cursor-not-allowed'}`}
            >
              {loading ? 'Criando...' : 'Criar Vínculo'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NovoVinculo;
